import { render, staticRenderFns } from "./Uploadbox.vue?vue&type=template&id=c5345680&"
import script from "./Uploadbox.vue?vue&type=script&lang=ts&"
export * from "./Uploadbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports